import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-iterate-video-large.tsx
/**
* icon.24.iterate.video.large
*
* Keywords: waveform, audio, sound, frequency, equalizer, vertical, bars, music
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE4LjUgOWEuNS41IDAgMCAxIC41LjVWMTZhMyAzIDAgMCAxLTMgM0g2LjIwNmwxLjE0NyAxLjE0NmEuNS41IDAgMCAxLS43MDcuNzA3bC0yLTJhLjUuNSAwIDAgMSAwLS43MDdsMi0yYS41LjUgMCAwIDEgLjcwNy43MDdMNi4yMDYgMThIMTZhMiAyIDAgMCAwIDItMlY5LjVhLjUuNSAwIDAgMSAuNS0uNW0tMS44NTMtNS44NTRhLjUuNSAwIDAgMSAuNzA3IDBsMiAyYS41LjUgMCAwIDEgMCAuNzA3bC0yIDJhLjUuNSAwIDAgMS0uNzA3LS43MDdMMTcuNzkzIDZIOGEyIDIgMCAwIDAtMiAydjYuNWEuNS41IDAgMCAxLTEgMFY4YTMgMyAwIDAgMSAzLTNoOS43OTNsLTEuMTQ2LTEuMTQ3YS41LjUgMCAwIDEgMC0uNzA3TTkuOTk4IDkuMTM1YTEgMSAwIDAgMSAuOTk4LS4wMDNsMy41IDJhMSAxIDAgMCAxIDAgMS43MzZsLTMuNSAyQTEgMSAwIDAgMSA5LjUgMTR2LTRhMSAxIDAgMCAxIC40OTgtLjg2NU0xMC41IDE0bDMuNS0yLTMuNS0yeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=25203-9825
*/
const Icon24IterateVideoLarge = memo(function Icon24IterateVideoLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M18.5 9a.5.5 0 0 1 .5.5V16a3 3 0 0 1-3 3H6.206l1.147 1.146a.5.5 0 0 1-.707.707l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .707.707L6.206 18H16a2 2 0 0 0 2-2V9.5a.5.5 0 0 1 .5-.5m-1.853-5.854a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.707-.707L17.793 6H8a2 2 0 0 0-2 2v6.5a.5.5 0 0 1-1 0V8a3 3 0 0 1 3-3h9.793l-1.146-1.147a.5.5 0 0 1 0-.707M9.998 9.135a1 1 0 0 1 .998-.003l3.5 2a1 1 0 0 1 0 1.736l-3.5 2A1 1 0 0 1 9.5 14v-4a1 1 0 0 1 .498-.865M10.5 14l3.5-2-3.5-2z"
		})
	});
});
//#endregion
export { Icon24IterateVideoLarge };

//# sourceMappingURL=icon-24-iterate-video-large.js.map